import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { BannerStandImagesState } from './types';
import { ListStatus, EditableStatus } from '@/store/types';

export const getters: GetterTree<BannerStandImagesState, RootState> = {
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsEmpty: (state) => state.list.length === 0,

  editableIsLoading: (state) => state.editableStatus === EditableStatus.Loading,
  editableIsLoaded: (state) => state.editableStatus === EditableStatus.Loaded,
  editableIsSaving: (state) => state.editableStatus === EditableStatus.Saving,
  editableIsSaved: (state) => state.editableStatus === EditableStatus.Saved,
  editableIsFailed: (state) => state.editableStatus === EditableStatus.Failed,
  editableHasUnsavedChanges: (state) => {
    if (!state.editable || !state.initialEditable) {
      return false;
    }
    return JSON.stringify(state.editable) !== JSON.stringify(state.initialEditable);
  },

  availableProducts: (state) => {
    const currentProductId = state.editable?.productId;
    return state.products.filter(
      (product) => !state.usedProducts.includes(product.id) || product.id === currentProductId
    );
  },
};

